module.exports = __webpack_public_path__ + "img/lr-cb66-1.70830e86.gif";